import { featureCollection, point } from '@turf/helpers'
import { toWgs84 } from '@turf/projection'
import $ from 'jquery'
import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'
import set from 'lodash/set'
import OLInteractionDraw from 'ol/interaction/Draw'
import OLLayerVector from 'ol/layer/Vector'
import OLSourceVector from 'ol/source/Vector'

import * as Model from 'api/model'
import * as PoziUtils from 'api/utils'
import PoziDrawer from 'drawer/drawer'
import PoziFeedback from 'drawer/tabs/info/feedback'
import PoziDrawerTabInfo from 'drawer/tabs/info/info'
import { resetCurrentTarget } from 'map/actions'
import PoziMap from 'map/map'
import PoziNotifications from 'utils/notifications'
import { targetSet } from 'utils/target'

export default function PoziAddFeature () {
  // Adapters
  const adapters = {
    init: function () {
      return init()
    },
    removeSelectedPointLayer: function () {
      return removeSelectedPointLayer()
    }
  }

  const app = PoziUtils.getApp()

  var init = function () {
    Model.on('app.event.layer.visible', addButton)
    Model.on('app.event.layer.invisible', removeButton)

    const label = Model.get('config.layout.drawer.tabs.info.addfeature.button.menu.label', '')
    if (label === '') {
      $('#add-feature-menu-label').hide()
    } else {
      Model.set('config.layout.drawer.tabs.info.addfeature.button.menu.label.visible', true)
      $('#add-feature-menu-label').html(label)
    }

    $('#add-feature-menu-button-wrapper').on('click', clickedAddFeatureMenuButton)
    // Model.on('app.map.target.mapclick', editButtonClicked)
    Model.on('app.event.drawer.opening', function (bVal) {
      if (bVal) {
        const currentWindowMode = Model.get('app.event.window.mode', '')
        if (currentWindowMode === 'mobile') {
          $('#add-feature-buttons-wrapper').hide()
        }
      }
    })
    Model.on('app.event.drawer.closed', function () {
      const numberOfButtons = $('.pozi-add-feature-layer-button').length
      if (numberOfButtons === 1) {
        $('#add-feature-layer-buttons button').removeClass('add-feature-small-buttons')
        $('#add-feature-buttons-wrapper').show()
        $('#add-feature-layer-buttons').css('bottom', '8px')
        $('#add-feature-layer-buttons').show()
        $('#add-feature-menu-button-wrapper').hide()
      } else if (numberOfButtons > 1) {
        $('#add-feature-layer-buttons button').addClass('add-feature-small-buttons')
        $('.add-feature-small-buttons img').css('height', '20px')
        $('#add-feature-buttons-wrapper').show()
        $('#add-feature-layer-buttons').css('bottom', '80px')
        $('#add-feature-layer-buttons').hide()
        $('#add-feature-menu-button-wrapper').show()
      } else {
        $('#add-feature-menu-button-wrapper').hide()
      }
    })
  }

  // This is used to remove the dot on map if the form is no longer visible.
  var removeSelectedPointLayer = function () {
    const olLayerAddFeatureSelectedPoint = Model.get('app.drawer.tabs.info.addfeature.selectedpointlayer', null)
    if (!isNil(olLayerAddFeatureSelectedPoint)) {
      PoziMap().removeLayer(olLayerAddFeatureSelectedPoint)
      Model.unset('app.drawer.tabs.info.addfeature.selectedpointlayer')
    }
  }

  var removeButton = function (layer) {
    if (!has(layer, 'drawer.tabs.info.create')) {
      // console.log('Not a form layer.', layer.titleid)
      return
    }
    console.log('Remove add feature button', layer.titleid)
    $('#_hj_feedback_container').show()
    $('.pozi-add-feature-layer-' + layer.titleid).remove()
    const numberOfButtons = $('.pozi-add-feature-layer-button').length
    if (numberOfButtons === 0) {
      $('#add-feature-menu-button-wrapper').hide()
    }
  }

  var addButton = function (layer) {
    console.debug('addButton', layer.titleid)

    if (!has(layer, 'drawer.tabs.info.create')) {
      // console.log('Not a form layer.', layer.titleid)
      return
    }

    /* if (has(layer, 'drawer.tabs.info.create.geoserver.auth')) {
      // console.log('Not a form layer.', layer.titleid)
      var bLoggedIn = Model.get('app.event.drawer.tabs.tools.auth.loggedin', false)
      if (!bLoggedIn) {
        return
      }
    } */

    const layerAlreadyHasButton = $('.pozi-add-feature-layer-' + layer.titleid).length > 0
    if (layerAlreadyHasButton) {
      console.log('Layer already has a button. Not adding again.', layer.titleid)

      return
    }

    console.log('Add feature button for', layer.titleid)
    $('#_hj_feedback_container').hide()
    $('.intercom-launcher-frame').hide()

    // If this is called as load it won't work because HotJar widget hasn't yet loaded.
    window.setTimeout(function () {
      $('#_hj_feedback_container').hide()
      $('.intercom-launcher-frame').hide()
    }, 1000)

    window.setTimeout(function () {
      $('#_hj_feedback_container').hide()
      $('.intercom-launcher-frame').hide()
    }, 3000)

    window.setTimeout(function () {
      $('#_hj_feedback_container').hide()
      $('.intercom-launcher-frame').hide()
    }, 10000)

    const template = $('.add-feature-layer-template').clone()
    $(template).removeClass('add-feature-layer-template')
    $(template).removeClass('hidden')
    $(template).addClass('pozi-add-feature-layer-button')
    $(template).addClass('pozi-add-feature-layer-' + layer.titleid)
    $(template).attr('titleid', layer.titleid)
    const buttonDescription = get(layer, 'drawer.tabs.info.create.button.description', '')
    $(template)
      .find('.add-feature-layer-label')
      .html(buttonDescription)
    const buttonIcon = get(layer, 'drawer.tabs.info.create.button.icon', '')
    $(template)
      .find('.add-feature-layer-button-img')
      .attr('src', buttonIcon)
    $(template).on('click', clickedAddFeature)
    $('#add-feature-layer-buttons').append(template)
    $('#add-feature-layer-buttons').hide()

    $('#add-feature-buttons-wrapper').show()
    $('#add-feature-menu-button-wrapper').show()
    const label = Model.get('config.layout.drawer.tabs.info.addfeature.button.menu.label', '')
    if (label !== '') {
      $('#add-feature-menu-label').show()
    }

    /* Show add button directly if there is only one. Else, show an add button sub menu. */
    const numberOfButtons = $('#add-feature-layer-buttons .pozi-add-feature-layer-button').length
    console.log('PoziAddFeature.addButton() numberOfButtons', numberOfButtons)
    if (numberOfButtons === 1) {
      $('#add-feature-layer-buttons button').removeClass('add-feature-small-buttons')
      $('#add-feature-layer-buttons').css('bottom', '8px')
      $('#add-feature-layer-buttons').show()
      $('#add-feature-menu-button-wrapper').hide()
    } else if (numberOfButtons > 1) {
      $('#add-feature-layer-buttons button').addClass('add-feature-small-buttons')
      $('.add-feature-small-buttons img').css('height', '20px')
      $('#add-feature-layer-buttons').css('bottom', '80px')
      $('#add-feature-layer-buttons').hide()
      $('#add-feature-menu-button-wrapper').show()
    }
  }

  var clickedAddFeatureMenuButton = function (evt) {
    console.log('Clicked add feature menu button...')

    const olLayerAddFeatureSelectedPoint = Model.get('app.drawer.tabs.info.addfeature.selectedpointlayer', null)
    PoziMap().removeLayer(olLayerAddFeatureSelectedPoint)

    PoziDrawer().hide()

    $('#add-feature-layer-buttons').toggle()

    const label = Model.get('config.layout.drawer.tabs.info.addfeature.button.menu.label', '')
    if (label !== '') {
      $('#add-feature-menu-label').toggle()
    }

    // Clear any old timeouts.
    // clearTimeoutAddFeature('cancelAfterTimeout', cancelAfterTimeout)
    // clearTimeoutAddFeature('hideButtonsAfterTimeout', hideButtonsAfterTimeout)

    // Set a timeout on the button.
    // setTimeoutAddFeature('hideButtonsAfterTimeout', finish, 15000)
  }

  var clickedAddFeature = function (evt) {
    console.debug('clickedAddFeature - Clicked add feature button...')

    Model.unset('app.drawer.tabs.info.addfeature.layer')
    const fiveMinsMS = 60 * 1000 * 5
    setTimeoutAddFeature('cancelAfterTimeout', finish, fiveMinsMS)

    const currentTarget = get(evt, 'currentTarget', null)
    window.store.dispatch(resetCurrentTarget())

    const titleid = $(currentTarget).attr('titleid')
    const layer = PoziUtils.getLayerFromTitleID(titleid)
    Model.set('app.event.drawer.tabs.info.card.options.layer', layer)
    Model.set('app.event.drawer.tabs.info.card.options.insert', true)
    if (isNil(layer)) {
      console.error('Unable to find layer from titleid', titleid)
      PoziNotifications().warning('Something went wrong... unable to add feature.')
      finish()
      return
    }
    console.log('Clicked add feature for layer', layer)
    Model.set('app.drawer.tabs.info.addfeature.layer', layer)

    const sourceVector = new OLSourceVector({ wrapX: false })
    Model.set('app.drawer.tabs.info.addfeature.source.vector', sourceVector)
    const olLayerAddFeatureSelectedPoint = new OLLayerVector({
      source: sourceVector
    })

    const selectedpointlayer = Model.get('app.drawer.tabs.info.addfeature.selectedpointlayer', null)
    if (selectedpointlayer) {
      PoziMap().removeLayer(selectedpointlayer)
    }
    Model.set('app.drawer.tabs.info.addfeature.selectedpointlayer', olLayerAddFeatureSelectedPoint)
    PoziMap().addLayer(olLayerAddFeatureSelectedPoint)

    const drawType = get(layer, 'drawer.tabs.info.create.draw.type', 'Point')

    // To work around a (potential) OL issue where the first click sometimes does not get
    // recorded, we get the interaction control to take care of handling the clicks by
    // absorbing the map click and calling the relevant routine after the 'drawend' event has
    // fired.
    const stopClick = drawType === 'Point'

    const olInteractionDraw = new OLInteractionDraw({
      source: sourceVector,
      stopClick: true, // we absorb and handle the clicks within the interaction control
      type: drawType
    })

    if (drawType === 'Point') {
      olInteractionDraw.on('drawend', (evt) => {
        // Now that we have completed the interaction, we can remove the control
        PoziMap().removeInteraction(olInteractionDraw)

        // Extract coordinates from event and call relevant callback method
        const coords = evt?.feature?.getGeometry()?.getCoordinates()
        singleClickMapAddFeature(coords)
      })

      PoziMap().addInteraction(olInteractionDraw)

      PoziNotifications().notify('Place a point on the map')
    } else {
      // TODO: find out if this ever gets used still. Maybe it was GeoServer related only?
      PoziMap().setDoubleClickInteraction(doubleClickMapAddFeature, olInteractionDraw)

      PoziNotifications().notify('Draw a line on the map')
    }

    PoziMap().setCursor({ class: 'cursor-add-feature', enable: true })

    console.log('Waiting for user to click a point on the map...')
  }

  var singleClickMapAddFeature = function (coords) {
    console.debug('singleClickMapAddFeature - User selected map point for add feature...', coords)

    finish()

    if (!coords) {
      console.warn('singleClickMapAddFeature - no coords provided. Not doing anything.')
      return
    }

    const coords4326 = app.transformTo4326(coords)
    const featureCollectionT = featureCollection([point(coords4326)])
    targetSet(featureCollectionT, { mapclick: true })
    mapPointSelected()

    return true // Allow MDL to do it's thing with the button effects.
  }

  var doubleClickMapAddFeature = function (evt) {
    console.debug('doubleClickMapAddFeature -User selected map linestring for add feature...', { ...evt })

    const sourceVector = Model.get('app.drawer.tabs.info.addfeature.source.vector', null)
    if (!isNil(sourceVector)) {
      const olFeaturesArr = sourceVector.getFeatures()
      let featureCollectionT = PoziUtils.convertOLFeatureArrToTurfFeature(olFeaturesArr)
      featureCollectionT = toWgs84(featureCollectionT)
      targetSet(featureCollectionT, { mapclick: false })
      Model.set('app.event.drawer.tabs.info.create.geoserver.click.event', evt)
      Model.set('app.event.drawer.tabs.info.create.geoserver.click.double', true)
    }
    finish()
    return false // Must return false to stop event propgation (returning true causes a map zoom event to fire)
  }

  var finish = function () {
    clearTimeoutAddFeature('cancelAfterTimeout')
    clearTimeoutAddFeature('hideButtonsAfterTimeout')
    // $('#add-feature-layer-buttons').hide()

    const label = Model.get('config.layout.drawer.tabs.info.addfeature.button.menu.label', '')
    if (label !== '') {
      $('#add-feature-menu-label').show()
    }
    PoziMap().setCursor({ class: 'cursor-add-feature', enable: false })
    PoziMap().enableDefaultMapClickInteration()
    Model.unset('app.drawer.tabs.info.addfeature.source')
  }

  var mapPointSelected = function () {
    $('#elt-tabs').hide()
    buildForm()
  }

  var clearTimeoutAddFeature = function (timeoutIDStr) {
    const timeoutID = Model.get('app.drawer.tabs.info.addfeature.' + timeoutIDStr, null)
    if (!isNil(timeoutID)) {
      console.log('Clearing timeout', timeoutIDStr, timeoutID)
      clearTimeout(timeoutID)
      Model.unset('app.drawer.tabs.info.addfeature.' + timeoutIDStr)
    }
  }

  var setTimeoutAddFeature = function (timeoutIDStr, func, milliseconds) {
    clearTimeoutAddFeature(timeoutIDStr)
    const timeoutID = window.setTimeout(() => func(), milliseconds)
    Model.set('app.drawer.tabs.info.addfeature.' + timeoutIDStr, timeoutID)
  }

  var buildForm = function () {
    const htmlID = 'pozi-drawer-tabs-panel-info-temp'
    const layer = Model.get('app.drawer.tabs.info.addfeature.layer', null)
    if (isNil(layer)) {
      console.error('Unable to render form. Layer not set')
      return
    }

    Model.set('app.feedback.layer', layer)

    const tabConfig = {}
    const url = get(layer, 'drawer.tabs.info.create.url', '')
    set(tabConfig, 'dataService.googleFormsURL', url)
    PoziFeedback().buildGoogleForm(htmlID, tabConfig)
    Model.set('app.drawer.activetabid', 'info')
    PoziDrawerTabInfo().tempMode()
  }

  // Return adapters (must be at end of adapter)
  return adapters
}
